import lo_ from '@/plugins/lodash.js';
import dayjs from '@/plugins/dayjs.js';
import i18n from '@/plugins/i18n.js';

export function formatChartConfig(config) {
  const startDate = dayjs(new Date()).subtract(6, 'month').format('YYYY-MM-DD');
  const endDate = dayjs(new Date()).format('YYYY-MM-DD');

  let defaultVal = null;
  let props = {};
  const { configs } = config;

  // rember remove
  config.name = config.name || 'test';

  switch (config.editor) {
    case 'textField':
      defaultVal = configs?.default || '';
      props = {
        name: config.name,
        placeholder: i18n.global.t('search')
      };
      break;
    case 'numberField':
      defaultVal = configs?.default || 0;
      props = {
        name: config?.name,
        min: configs?.minimum || 0,
        max: configs?.maximum || Infinity,
        placeholder: configs?.placeholder || '',
        preContext: configs?.preContext || '',
        postContext: configs?.postContext || ''
      };
      break;
    case 'slider':
      defaultVal = configs?.default || 0;
      props = {
        width: '100%',
        min: configs?.min,
        max: configs?.max,
        marks: [configs?.min, configs?.max],
        tooltip: 'focus',
        interval: lo_.has(configs, 'forceInt') ? (configs.forceInt ? 1 : 0.1) : 1,
        prefix: configs?.prefix || '',
        postfix: configs?.postfix || '',
        minPrefix: configs?.minPrefix || '',
        maxPrefix: configs?.maxPrefix || '',
        minPostfix: configs?.minPostfix || '',
        maxPostfix: configs?.maxPostfix || ''
      };
      break;
    case 'rangeSlider':
      defaultVal = [configs?.defaultFrom, configs?.defaultTo] || [];
      props = {
        width: '100%',
        min: configs?.min,
        max: configs?.max,
        marks: [configs?.min, configs?.max],
        tooltip: 'focus',
        interval: lo_.has(configs, 'forceInt') ? (configs.forceInt ? 1 : 0.1) : 1,
        prefix: configs?.prefix || '',
        postfix: configs?.postfix || '',
        minPrefix: configs?.minPrefix || '',
        maxPrefix: configs?.maxPrefix || '',
        minPostfix: configs?.minPostfix || '',
        maxPostfix: configs?.maxPostfix || ''
      };
      break;
    case 'date':
      defaultVal = dayjs(configs?.default).format() || endDate;
      props = {
        name: config?.name,
        showRanges: false,
        singleDatePicker: true
      };

      if (configs?.minimum) {
        props.min = configs?.minimum;
      }

      if (configs?.maximum) {
        props.max = configs?.maximum;
      }
      break;
    case 'dateRange':
      defaultVal = configs?.default || [startDate, endDate];
      props = {
        name: config.name,
        min: configs?.minimum,
        max: configs?.maximum
      };
      break;
    case 'selects':
      defaultVal = configs?.default || configs?.choices[0]?.id;
      props = {
        name: config.name,
        items:
          configs?.choices.map((item) => ({
            text: item.text,
            value: item.id
          })) || [],
        lazyLoad: configs?.lazyLoad,
        fetchApi: configs?.fetchApi,
        idField: configs?.idField,
        nameField: configs?.nameField
      };
      break;
    case 'tabs':
      defaultVal = configs?.default || configs?.choices[0]?.id;
      props = {
        items:
          configs?.choices?.map((item) => ({
            text: item.text,
            value: item.id
          })) || [],
        name: config?.name
      };
      break;
    case 'radio':
      defaultVal = configs?.default || configs?.choices[0]?.id;
      props = {
        items:
          configs?.choices?.map((item) => ({
            text: item.text,
            value: item.id
          })) || []
      };
      break;
    case 'checkbox':
      defaultVal = configs?.default || false;
      props = {
        text: config?.name
      };
      break;
    case 'checkboxGroup':
      defaultVal = configs?.default || [configs?.choices[0]?.id];
      props = {
        items:
          configs?.choices?.map((item) => ({
            text: item.text,
            value: item.id
          })) || []
      };
      break;
    case 'autocomplete':
      defaultVal = configs?.default || [];
      props = {
        items:
          configs?.choices?.map((item) => ({
            text: item.text,
            value: item.id
          })) || [],
        searchable: true,
        multiple: true,
        fetchApi: configs?.fetchApi,
        lazyLoad: configs?.lazyLoad,
        idField: configs?.idField,
        nameField: configs?.nameField
      };
      break;
    case 'asset':
      defaultVal = configs?.default || '';
      props = configs;
      break;
    case 'schedule':
      defaultVal = configs?.default || {};
      props = configs;
      break;
    default:
      defaultVal = 0;
      break;
  }
  return {
    defaultVal,
    props
  };
}
